import { render, staticRenderFns } from "./ProductsSearch.vue?vue&type=template&id=5caeccf4&"
import script from "./ProductsSearch.vue?vue&type=script&lang=js&"
export * from "./ProductsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports